export const productMessages = {
  'detail.addCart': '加入购物车',
  'detail.addOk': '已成功加入购物车！',
  'detail.adding': '加入中…',
  'detail.avg': '均分',
  'detail.favCount': '收藏',
  'detail.favFail': '收藏失败',
  'detail.favorite': '♡ 收藏',
  'detail.favorited': '♥ 已收藏',
  'detail.guestTip': '您当前为游客，登录后可加购、收藏、评价',
  'detail.myRate': '我的评价：',
  'detail.noDesc': '暂无详细描述',
  'detail.premium': '优质商品',
  'detail.rateFail': '评价失败',
  'detail.ratePrompt': '为商品打分（1～5 星）',
  'detail.reviewWrap': '（{n} 条）',
  'detail.reviewsShort': '条',
  'detail.sold': '已售',
  'detail.stock': '库存',
  'productList.allCats': '全部分类',
  'productList.empty': '暂无商品，请联系管理员添加',
  'productList.errHint': '请确认后端服务已启动，然后刷新页面',
  'productList.loadFail': '加载商品失败',
  'productList.noMatch': '没有符合条件的商品，试试清空筛选',
  'productList.of': '/',
  'productList.retry': '重新加载',
  'productList.searchPh': '搜索商品名、店铺名…',
  'productList.showing': '展示',
  'productList.sortDefault': '综合排序',
  'productList.sortPriceAsc': '价格从低到高',
  'productList.sortPriceDesc': '价格从高到低',
  'productList.sortSales': '销量优先',
  'productList.sub': '来自全国各地的优质商品，品质保证，快速配送',
  'productList.title': '精选商品',
  'productList.unit': '件',
  'shop.badgePremium': '优质店铺',
  'shop.defaultTagline': '用心选好物',
  'shop.empty': '暂无上架商品',
  'shop.followers': '粉丝',
  'shop.goodsTitle': '店铺商品',
  'shop.loadFail': '加载店铺失败',
  'shop.onSale': '在售',
  // 评价相关
  'review.title': '商品评价',
  'review.count': '条评价',
  'review.all': '全部',
  'review.empty': '暂无评价，快来抢沙发吧~',
  'review.noFiltered': '该筛选条件下暂无评价',
  'review.noContent': '用户未填写评价内容',
  // 分页
  'pagination.total': '共 {n} 条',
  'pagination.perPage': '条/页',
  'pagination.prev': '上一页',
  'pagination.next': '下一页',
  // 独立搜索页
  'search.button': '搜索',
  'search.pagePlaceholder': '搜索商品、店铺…',
  'search.history': '搜索历史',
  'search.hot': '热门搜索',
  'search.clearHistory': '清空',
  'search.resultCount': '找到 {n} 个商品',
  'search.noResult': '未找到相关商品',
  'search.noResultHint': '换个关键词试试吧',
  // 商品比较
  'compare.title': '商品比较',
  'compare.field': '属性',
  'compare.selected': '已选 {n} 件商品',
  'compare.compareBtn': '开始比较',
  'compare.minHint': '至少选2件',
  'compare.clearAll': '清空',
  'compare.empty': '还没有选择要比较的商品',
  'compare.goShopping': '去逛逛',
  'compare.price': '价格',
  'compare.originalPrice': '原价',
  'compare.category': '分类',
  'compare.shop': '店铺',
  'compare.shopCredit': '店铺信用',
  'compare.sales': '销量',
  'compare.stock': '库存',
  'compare.rating': '评分',
  'compare.reviewCount': '评价数',
  'compare.favCount': '收藏数',
  'compare.isPremium': '优质商品',
  'compare.addToCompare': '加入对比',
};
